var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "landing_wrap pb-0", attrs: { id: "wrap" } },
    [
      _c("div", { staticClass: "dim" }),
      _vm._v(" "),
      _c("div", { staticClass: "container_wrap" }, [
        _c("div", { staticClass: "loader_table" }, [
          _vm._m(0),
          _vm._v(" "),
          !_vm.isError
            ? _c("p", [_vm._v("Loading")])
            : _c("p", { domProps: { innerHTML: _vm._s(_vm.errorMsg) } })
        ])
      ]),
      _vm._v(" "),
      _c("keep-alive", [_c("recommend-pop")], 1)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader_box" }, [
      _c("div", { staticClass: "loader" }, [
        _c("span", { staticClass: "sr_only" }, [_vm._v("Loading...")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c906f11", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c906f11","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/myKnowledge/Register.vue
// module id = /jmi
// module chunks = 0